import MessagingTemplateFormLayout from './messagingTemplateFormLayout.container';

export default MessagingTemplateFormLayout;
